import React from 'react';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import FingerprintRoundedIcon from '@mui/icons-material/FingerprintRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import PhotoCameraRoundedIcon from '@mui/icons-material/PhotoCameraRounded';
import AppCheckInsTab from '../components/LeaveAttendanceComps/AppCheckInsTab';
import TabbedPage from'../components/TabbedPage';
import StaffAttendanceOverviewPage from '../components/LeaveAttendanceComps/StaffAttendanceOverviewPage';
import AddStaffAttendancePage from '../components/LeaveAttendanceComps/AddStaffAttendancePage';
import AttendanceReportsPage from '../components/LeaveAttendanceComps/AttendanceReportsPage';
import BiometricStaffMappingPage from '../components/LeaveAttendanceComps/BiometricStaffMappingPage';
import PunchRequestsTab from '../components/LeaveAttendanceComps/PunchRequestsTab';

const TABS = [
    { key: 'overview', label: 'Overview', icon: GridViewRoundedIcon, module: 'attendance-overview', render: () => <StaffAttendanceOverviewPage /> },
    { key: 'attendance', label: 'Attendance', icon: HowToRegRoundedIcon, module: 'attendance', render: () => <AddStaffAttendancePage /> },
    { key: 'reports', label: 'Reports', icon: AssessmentRoundedIcon, module: 'attendance-reports', render: () => <AttendanceReportsPage /> },
    { key: 'punch-requests', label: 'Punch Requests', icon: PendingActionsRoundedIcon, module: 'attendance', render: () => <PunchRequestsTab /> },
    { key: 'app-checkins', label: 'App Check-ins', icon: PhotoCameraRoundedIcon, module: 'attendance', render: () => <AppCheckInsTab /> },
    { key: 'biometric-mapping', label: 'Biometric Mapping', icon: FingerprintRoundedIcon, module: 'attendance', render: () => <BiometricStaffMappingPage isEmbedded /> },
];

export default function AttendanceLeavePage() {
    return <TabbedPage tabs={TABS} />;
}
